import { encodeURIPath } from '@!/Util/string'

export const buildSearchUrl = (type, searchTerm, tabName) => {
  // encodeURIPathの第2引数をfalseにして、検索語のドット「.」をスペースに変換しない（例：ジャンプSQ.などの雑誌名に対応）
  let url = `/store/search/${type}/${encodeURIPath(searchTerm, false)}`

  // カテゴリ検索の場合のみ、ジャンル名をパスに含める。
  if (type === 'category' && tabName && tabName !== 'home') {
    url += `/${tabName}`
  }

  return url
}
